export const COLUMN_HEADER_VARIANT = 'regular12';
export const DATA_ROW_VARIANT = 'regular14';
export const ICON_STYLE = { width: 16, height: 16 };
export const DRAG_ICON_STYLE = { fontSize: 18, cursor: 'grab' };
export const DROPPABLE_ID = 'signing-rules';
